import config from "../config/config";
import axios from "axios";
import { getToken } from "../Token";
import { getTimezoneInfo } from '../helpers/timezone_helper';

const { timezoneName, formattedOffset } = getTimezoneInfo();
const token = getToken();

export const OfficialHolidaysApi = {
    getOfficialHolidays: async (data) => {
        const axiosConfig = {
            method: 'post',
            url: `${config.API_URL}/superadmin/get-official-holidays`,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'Timezone-Name': timezoneName,
                'Timezone-Offset': formattedOffset
            },
            data
        };
        return await axios(axiosConfig);
    },

    createOfficialHoliday: async (data) => {
        const axiosConfig = {
            method: 'post',
            url: `${config.API_URL}/superadmin/create-official-holiday`,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'Timezone-Name': timezoneName,
                'Timezone-Offset': formattedOffset
            },
            data
        };
        return await axios(axiosConfig);
    },

    fetchOfficialHolidayById: async (official_holiday_id) => {
        const axiosConfig = {
            method: 'post',
            url: `${config.API_URL}/superadmin/fetch-official-holiday-by-id`,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'Timezone-Name': timezoneName,
                'Timezone-Offset': formattedOffset
            },
            data: { official_holiday_id }
        };
        return await axios(axiosConfig);
    },

    updateOfficialHoliday: async (data) => {
        const axiosConfig = {
            method: 'post',
            url: `${config.API_URL}/superadmin/update-official-holiday`,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'Timezone-Name': timezoneName,
                'Timezone-Offset': formattedOffset
            },
            data
        };
        return await axios(axiosConfig);
    },

    deleteOfficialHoliday: async (official_holiday_id) => {
        const axiosConfig = {
            method: 'post',
            url: `${config.API_URL}/superadmin/delete-official-holiday`,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
                'Timezone-Name': timezoneName,
                'Timezone-Offset': formattedOffset
            },
            data: { official_holiday_id }
        };
        return await axios(axiosConfig);
    }
}; 